export default "__VITE_ASSET__Bm$gRxrL__"